export enum ApplicationProcessActionTypes {
  GetCurrentApplication = 'applicationProcess/getCurrentApplication',
  UpdateCurrentApplication = 'applicationProcess/updateCurrentApplication',
  SaveIncomeSources = 'applicationProcess/saveIncomeSources',
  SaveBankInformation = 'applicationProcess/saveBankInformation',
  SaveTermsOfUseAcceptance = 'applicationProcess/saveTermsOfUseAcceptance',
  UploadDocuments = 'applicationProcess/uploadDocuments',
  HandleDocumentsUploaded = 'applicationProcess/handleDocumentsUploaded',
  GpsGatewayCheck = 'applicationProcess/gpsGatewayCheck',
  WellsFargoCheck = 'applicationProcess/wellsFargoCheck',
  SaveSelectedOffer = 'applicationProcess/saveSelectedOffer',
  SelectBankAccount = 'applicationProcess/selectBankAccount',
  CreditAndAutoOriginationCheck = 'applicationProcess/creditAndAutoOriginationCheck',
  OrganicCreditAndAutoOriginationCheck = 'applicationProcess/organicCreditAndAutoOriginationCheck',
  RefiCreditCheck = 'applicationProcess/refiCreditCheck',
  RefiAutoOriginationCheck = 'applicationProcess/refiAutoOriginationCheck',
  GetPlaidLinkToken = 'applicationProcess/getPlaidLinkToken',
  PlaidIdentityMatch = 'applicationProcess/plaidIdentityMatch',
  GetSigningUrl = 'applicationProcess/getSigningUrl',
  CompleteSigning = 'applicationProcess/completeSigning',
  SaveAutoPayOption = 'applicationProcess/saveAutoPayOption',
  RunSnowflakeRefiScoreCheck = 'applicationProcess/runSnowflakeRefiScoreCheck',
  RunSnowflakeRefiReloanCheck = 'applicationProcess/runSnowflakeRefiReloanCheck',
  HandleOrganicLoanOfferViewed = 'applicationProcess/handleOrganicLoanOfferViewed',
  UpdatePageDisplayedTechnical = 'applicationProcess/updatePageDisplayedTechnical',
  RunApplicationSummitLead = 'applicationProcess/runApplicationSummitLead',
  RunSecondChanceCashflowAndAutoOrigination = 'applicationProcess/runSecondChanceCashflowAndAutoOrigination',
  HandleDeclineApplication = 'applicationProcess/HandleDeclineApplication',
}
